<template>
	<div class="container">
		<!-- <CreateStepHeader :tmzId="0" /> -->
		<!--    <p class="step-name">Создание ликвидного востребованного отчета</p>-->
		<!-- <p class="step-name" style="font-size: 20px">
			Остатки востребованных ТМЗ за предыдущие финансовые годы
		</p> -->
		<div class="download-btn-container">
<!--			<a :href="downloadUrl" download>-->
<!--				<button class="download-btn" type="button">-->
<!--					Скачать шаблон-->
<!--				</button>-->
<!--			</a>-->
      <div class="download-btn-container-inner">
				<button class="download-btn" type="button" @click="downloadTemplate('s1')" id="v-step-tmz-download-template">
					Скачать шаблон
				</button>
				<a :href="downloadInstructionTmz" download>
					<button
						class="transition-all py-5 ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
					>
						Скачать инструкцию по 1 шагу
					</button>
				</a>
			</div>
			<!-- <button class="info-btn">
				<span class="material-icons-sharp info-btn-icon" @mouseover="showInfoModal">help</span>
			</button> -->
			<div class="icon" @mouseover="showInfoModal">
				<div class="icon-help-color icon-circle-main"></div>
				<div class="icon-circle-sub-main">
					<div class="custom-icons-container">
						<span class="custom-icons icon-help">help</span>
					</div>
				</div>
			</div>
		</div>

		<div class="dropzone">
			<input
				type="file"
				class="input-field"
				ref="file"
				@change="sendFile"
			/>
			<div v-if="!uploading" class="call-to-action">
				<p class="step-number">Шаг 1</p>
				Остатки востребованных ТМЗ за предыдущие финансовые годы
				<div role="button">Выбрать файл с компьютера</div>
			</div>
			<div v-if="uploading & (uploadProgress < 100)" class="progress-bar">
				<progress class="progress" :value="uploadProgress" max="100">
					{{ uploadProgress }} %
				</progress>
			</div>
			<div
				v-if="uploading & (uploadProgress == 100)"
				class="loading-status"
			>
				Документ загружен, идет обработка...
				<div class="spinner">
					<div id="dot1" class="dot"></div>
					<div id="dot2" class="dot"></div>
					<div id="dot3" class="dot"></div>
					<div id="dot4" class="dot"></div>
					<div id="dot5" class="dot"></div>
				</div>
			</div>
			<div
				v-show="!uploading"
				class="skip-btn"
				@click="skipVl1"
				role="button"
				id="v-step-tmz-skip"
			>
				Пропустить
			</div>
		</div>

		<modal name="file-modal">
			<div class="modal-inner">
				<div>
					Следует загружать следующие типы файлов: xlsx, xls
				</div>
				<button @click="closeModal">Понятно</button>
			</div>
		</modal>

		<modal name="info-modal" :width="800"
         :height="450"
         :adaptive="true">
			<div class="modal-inner">
				<div class="info-modal-container">
					<div class="slider">
  
						<a href="#slide-1">1</a>
						<a href="#slide-2">2</a>
						<a href="#slide-3">3</a>
						<a href="#slide-4">4</a>
						<a href="#slide-5">5</a>
						<a href="#slide-6">6</a>
						<a href="#slide-7">7</a>
						<a href="#slide-8">8</a>

						<div class="slides">
							<div id="slide-1">
								Если ваш отчет загрузился на портал, но его содержимое на портале отображается нулями, убедитесь, что отчет начинается с 7 строки Excel
							</div>
							<div id="slide-2">
								Если у вас ошибка «колонка F или G должно совпадать со старым значением которое вы ввели выше» Вам необходимо проверить данную позицию у себя в отчете и сравнить колонку F и G, со значением этого же товара на верхних строках отчета
							</div>
							<div id="slide-3">
								В случае, если у Вас все в порядке во всех строках по одному и тому же товару везде идентично ТМЦ или ОС, то просим вас скинуть загружаемый файл к нам на почту sultan.ryspekov@internet.ru
							</div>
							<div id="slide-4">
								В случае если у Вас один и тот же товар, в разных строках отличается, Вам необходимо изменить на соответствующее значение
							</div>
							<div id="slide-5">
								Если у вас ошибка связанная с несовпадением остатков с конца предыдущего месяца на начало текущего месяца. Обратите внимание что данные идентичны, к примеру у вас на конец месяца Января было 10 шт ручек, на начало месяца Февраль Вам необходимо указать 10 шт ручек, никак ни больше ни меньше
							</div>
							<div id="slide-6">
								В графе дата поступления нельзя указывать будущую дату
							</div>
							<div id="slide-7">
								Если у Вас вышла ошибка «Данная позиция отсутствует в остатках предыдущего месяца», проверьте загружаемый файл и удалите эту позицию
							</div>
							<div id="slide-8">
								Если у вас вышла ошибка «Вы не указали данную позицию», то значит эта позицая была в прошлом месяце и по ней есть остатки, и вы ее не внесли в отчет этого месяца
							</div>
						</div>
					</div>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
import CreateStepHeader from '@/components/tmz/CreateStepHeader';
import axios from 'axios';
import {mapGetters} from 'vuex';
import NProgress from 'nprogress';
import store from '../../store'

export default {
	name: 'CreateLiquidReportOne',
	data() {
		return {
			step: 1,
			uploading: false,
			progress: 0,
			showModal: false,
			downloadInstructionTmz: `${process.env.VUE_APP_MEDIA_URL}/media/tmz/1_шаг.pdf`,
			// downloadInstructionTmz: `https://metall.kmg.kz/media/tmz/1_шаг.pdf`,
		};
	},
	components: {
		CreateStepHeader,
	},
	computed: {
		...mapGetters(['uploadProgress']),
	},
	methods: {
		showInfoModal () {
			this.$modal.show('info-modal');
		},
    downloadTemplate (step) {
			let payload = {
				type: step
			}

			axios.get('/tmz/template-tmz/', {
				params: payload
			}).then((response) => {
				const url = response.data[0].file_data
				const link = document.createElement('a')
				link.href = url
				link.setAttribute('download', response.data[0].file_name)
				document.body.appendChild(link)
				link.click()
			})
      // this.$store.tmz.downloadTemplate(step)
			// console.log(`step ${step}`)
    },
		async sendFile() {
			const file = this.$refs.file.files[0];
			let fileName = document.querySelector('.input-field').value,
				idxDot = fileName.lastIndexOf('.') + 1,
				extFile = fileName
					.substr(idxDot, fileName.length)
					.toLowerCase();

			const formData = new FormData();
			formData.append('file', file);
			formData.append('type', 'liquid');

			if (!(extFile == 'xlsx' || extFile == 'xls' || extFile == 'xlsm')) {
				this.$modal.show('file-modal');
				this.file = null;
			} else {
				try {
					NProgress.start();
					this.uploading = true;
					this.$store
						.dispatch('uploadVl1', formData)
						.then((response) => {
							NProgress.done();
						});
				} catch (e) {
					console.log(e);
				}
			}
		},
		skipVl1() {
			this.$store.dispatch('skipVl1');
		},
		closeModal() {
			this.$modal.hide('file-modal');
		},
	},
	mounted() {
		let hasVisitedTmz = localStorage.getItem('hasVisitedTmz');
			console.log(hasVisitedTmz)
			if (!hasVisitedTmz) {
					this.$tours['tmzTour'].start()
			}
	}
};
</script>

<style scoped>
.container {
	display: flex;
	flex-direction: column;
	justify-content: center;
	min-height: 100vh;
}

.step-name {
	text-align: center;
}

.download-btn-container {
	display: flex;
	/* justify-content: flex-end; */
	/* padding: 2rem 0; */
	gap: 2rem;
	justify-content: space-between;
}

.download-btn-container-inner {
	display: flex;
	gap: 1rem;
	/* min-height: 50px; */
}

.download-btn {
	padding: 1rem 2rem;
	border: none;
	outline: none;
	border-radius: 10px;
	cursor: pointer;
	font-size: 1.1rem;
	background: #36429e;
	color: white;
}

.skip-btn {
	background: #00d1b2;
}

.dropzone {
	margin-top: 3rem;
	height: 250px;
	min-height: 250px;
	padding: 10px;
	position: relative;
	cursor: pointer;
	border: 5px dashed #dddddd;
	outline-offset: 10px;
	background: lightcyan;
	color: dimgray;
}

.input-field {
	opacity: 0;
	width: 100%;
	height: 100%;
	position: absolute;
	cursor: pointer;
}

.dropzone:hover {
	background: lightblue;
	transition: all 300ms ease;
}

.dropzone .call-to-action {
	font-size: 1.5rem;
	text-align: center;
	padding: 70px 0;
}

.call-to-action > div {
	font-size: 1rem;
	padding: 1rem 2rem;
	background: #00d1b2;
	max-width: 300px;
	margin: 1rem auto;
	border-radius: 20px;
	color: #fff;
}

.skip-btn {
	position: absolute;
	bottom: 20px;
	right: 20px;
	background: #36429e;
	color: white;
	padding: 1rem 2rem;
	border-radius: 25px;
}

.loading-status {
	min-height: inherit;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 2rem;
}


.info-modal-container {
	text-align: left;
}

ol li {
    list-style: decimal;
    list-style-position: inside;
}

</style>
